var $ = require('jquery');
// var styleguide = require("./modules/style-guide.js");
var accordions = require("./modules/accordions.js");
// var cards = require("./modules/cards.js");
var circlesLib = require('./vendor/circles.js');
var circleEffect = require('./modules/circles.js');
var menu = require('./modules/menu.js');
// var sliders = require("./modules/sliders.js");
// var svg = require("./modules/svg.js");
var MainMenuTabbing = require('./modules/mainMenuTabber.js');
var pageContainerMargin = require('./modules/pageContainerMargin.js');

// Make sure that you init the styleguide first.
// styleguide.init();
accordions.init();
circleEffect.init();
// cards.init();
menu.init();
// sliders.init();
// svg.init();
MainMenuTabbing.init();

if (!document.body.classList.contains('home')) {
	pageContainerMargin.init();
}
